import { inject } from '@angular/core';
import { Router, CanActivateFn, ActivatedRouteSnapshot } from '@angular/router';
import { StorageService } from '../services/storage.service';
import { TreatmentService } from '../services/treatment.service';
import { map, catchError, of } from 'rxjs';

export const treatmentGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const storage = inject(StorageService);
  const treatmentService = inject(TreatmentService);
  const router = inject(Router);
  const currentPath = window.location.href || '';

  const hashFromUrl = route.queryParamMap.get('hash');

  if (!hashFromUrl) {
    const savedHash = storage.getHash();
    const savedTreatment = storage.getTreatment();

    if (!savedHash || !savedTreatment) {
      router.navigate(['/error'], { queryParams: { type: '403' } });
      return false;
    }

    return true;
  }

  if (currentPath.includes('review')) {
    storage.setForReview(true);
  }

  storage.setHash(hashFromUrl);

  return treatmentService.fetchTreatmentByHash(hashFromUrl).pipe(
    map(() => true),
    catchError(() => {
      router.navigate(['/error'], { queryParams: { type: '403' } });
      return of(false);
    })
  );
};
